/*============================================================================
  Favorites System for Motion Theme / globo swatches
==============================================================================*/

theme.Favorites = (() => {
	var config = {
		storageKey: 'shopify_favorites',
		maxFavorites: 100
	};

	var selectors = {
		favoriteBtn: '.js-favorite-btn',
		favoriteBubble: '.favorites-link__bubble',
		favoriteCount: '.favorites-link__bubble-num',
		heartIcon: '.favorite-heart'
	};

	var classes = {
		isFavorited: 'is-favorited',
		bubbleVisible: 'favorites-link__bubble--visible'
	};

	let pageType;

	// Initialize favorites system
	function init() {
		bindEvents();
		updateAllHeartStates();
		updateFavoritesCount();
	}

	// Bind click events to favorite buttons
	const bindEvents = () => {
		document.addEventListener('click', function (evt) {
			var favoriteBtn = evt.target.closest(selectors.favoriteBtn);
			if (favoriteBtn) {
				evt.preventDefault();
				evt.stopPropagation();
				evt.stopImmediatePropagation();
				toggleFavorite(favoriteBtn);
				return false;
			}
		});

		// Listen for page changes (for ajax collection filtering)
		document.addEventListener('page:loaded', function () {
			updateAllHeartStates();
		});
	};

	// Toggle favorite status for a product
	function toggleFavorite(btn) {
		var productId = btn.dataset.productId;

		let price;
		let noPrice = 'See product page';

		switch (theme.Favorites.pageType) {
			case 'product':
				price = `from ${getLowestVariantPrice()}` || noPrice;
				break;

			case 'collection':
				price =
					btn.dataset.productPrice ||
					btn.getAttribute('data-product-price') ||
					noPrice;
				break;

			default:
				price = noPrice;
		}

		var productData = {
			id: productId,
			handle: btn.dataset.productHandle,
			title: btn.dataset.productTitle,
			price: price,
			image: btn.dataset.productImage,
			url: btn.dataset.productUrl
		};

		if (isFavorited(productId)) {
			removeFavorite(productId);
			btn.classList.remove(classes.isFavorited);
		} else {
			addFavorite(productData);

			// Track favorite added to GA4
			if (typeof gtag !== 'undefined') {
				gtag('event', 'favorite_added', {
					item_id: productData.id,
					item_name: productData.title,
					item_url: productData.url,
					item_image: productData.image,
					value:
						parseFloat(
							(productData.price || '0').replace(/[^\d.-]/g, '')
						) || 0,
					currency: 'GBP',
					custom_parameters: {
						product_handle: productData.handle
					}
				});
			}

			btn.classList.add(classes.isFavorited);
		}

		updateFavoritesCount();

		// Dispatch custom event for other components to listen
		document.dispatchEvent(
			new CustomEvent('favorites:updated', {
				detail: {
					productId: productId,
					isFavorited: isFavorited(productId),
					count: getFavorites().length
				}
			})
		);
	}

	// return lowest variant price from array
	const getLowestVariantPrice = () => {
		const container = document.querySelector(
			'.globo-swatch-detail-lists-price'
		);
		if (!container) return false;

		const priceSpans = container.querySelectorAll('.gw-li-price');
		if (priceSpans.length === 0) return false;

		// Create array of objects: { raw: "$41.00", value: 41 }
		const priceObjects = Array.from(priceSpans)
			.map((span) => {
				const raw = span.textContent.trim();
				const value = parseFloat(raw.replace(/[^\d.]/g, ''));
				return !isNaN(value) ? { raw, value } : null;
			})
			.filter(Boolean); // remove nulls

		if (priceObjects.length === 0) return false;

		// Find object with the lowest numeric value
		const lowest = priceObjects.reduce((min, curr) =>
			curr.value < min.value ? curr : min
		);

		return lowest.raw; // e.g., "$41.00"
	};

	// Add product to favorites
	const addFavorite = (productData) => {
		var favorites = getFavorites();

		// Check if already exists
		if (!favorites.find((item) => item.id === productData.id)) {
			// Respect max limit
			if (favorites.length >= config.maxFavorites) {
				favorites = favorites.slice(1); // Remove oldest
			}

			favorites.push({
				...productData,
				dateAdded: new Date().toISOString()
			});

			saveFavorites(favorites);
			updateFavoritesCount();
		}
	};

	// Remove product from favorites
	const removeFavorite = (productId) => {
		var favorites = getFavorites();

		// Find the product being removed for GA tracking
		var removedProduct = favorites.find((item) => item.id === productId);

		favorites = favorites.filter((item) => item.id !== productId);
		saveFavorites(favorites);
		updateFavoritesCount();

		// Track favorite removed to GA4
		if (typeof gtag !== 'undefined' && removedProduct) {
			gtag('event', 'favorite_removed', {
				item_id: removedProduct.id,
				item_name: removedProduct.title,
				item_url: removedProduct.url,
				item_image: removedProduct.image,
				value:
					parseFloat(
						(removedProduct.price || '0').replace(/[^\d.-]/g, '')
					) || 0,
				currency: 'GBP',
				custom_parameters: {
					product_handle: removedProduct.handle
				}
			});
		}
	};

	// Check if product is favorited
	const isFavorited = (productId) => {
		var favorites = getFavorites();
		return favorites.some((item) => item.id === productId);
	};

	// Get all favorites from localStorage
	const getFavorites = () => {
		try {
			var stored = localStorage.getItem(config.storageKey);
			return stored ? JSON.parse(stored) : [];
		} catch (e) {
			console.warn('Favorites: Unable to access localStorage');
			return [];
		}
	};

	// Save favorites to localStorage
	const saveFavorites = (favorites) => {
		try {
			localStorage.setItem(config.storageKey, JSON.stringify(favorites));
		} catch (e) {
			console.warn('Favorites: Unable to save to localStorage');
		}
	};

	// Update all heart icons on the page
	const updateAllHeartStates = () => {
		document
			.querySelectorAll(selectors.favoriteBtn)
			.forEach(function (btn) {
				var productId = btn.dataset.productId;
				if (isFavorited(productId)) {
					btn.classList.add(classes.isFavorited);
				} else {
					btn.classList.remove(classes.isFavorited);
				}
			});
	};

	// Update favorites count in header
	const updateFavoritesCount = () => {
		var count = getFavorites().length;
		var countEls = document.querySelectorAll(selectors.favoriteCount);
		var bubbles = document.querySelectorAll(selectors.favoriteBubble);

		// Update count numbers
		countEls.forEach(function (el) {
			el.textContent = count;
		});

		// Show/hide bubbles
		bubbles.forEach(function (bubble) {
			if (count > 0) {
				bubble.classList.add(classes.bubbleVisible);
			} else {
				bubble.classList.remove(classes.bubbleVisible);
			}
		});
	};

	// Public API
	return {
		init: init,
		addFavorite: addFavorite,
		removeFavorite: removeFavorite,
		isFavorited: isFavorited,
		getFavorites: getFavorites,
		updateAllHeartStates: updateAllHeartStates,
		updateFavoritesCount: updateFavoritesCount,
		toggleFavorite: toggleFavorite
	};
})();

/*============================================================================
  Collection Grid Heart Injection
==============================================================================*/
theme.collectionHearts = (() => {
	function init() {
		if (!document.body.classList.contains('template-collection')) {
			return false;
		}

		addHeartsToGrid();
		// Re-add hearts when collection updates (filtering, sorting, pagination)
		document.addEventListener('collection:updated', addHeartsToGrid);
		document.addEventListener('page:loaded', addHeartsToGrid);

		return true;
	}

	const addHeartsToGrid = () => {
		// Find all product grid items that don't already have hearts
		const gridItems = document.querySelectorAll(
			'.grid-product:not([data-heart-added])'
		);

		gridItems.forEach(function (gridItem) {
			// Mark this item as processed
			gridItem.setAttribute('data-heart-added', 'true');

			// Extract product data
			const productData = extractProductData(gridItem);
			if (!productData) {
				return;
			}

			// Create heart button
			const heartButton = createHeartButton(productData);

			// Find the best place to insert the heart (usually the image container)
			const imageContainer = findImageContainer(gridItem);
			if (imageContainer) {
				// Make sure the container is positioned relative for absolute positioning
				if (getComputedStyle(imageContainer).position === 'static') {
					imageContainer.style.position = 'relative';
				}
				imageContainer.appendChild(heartButton);

				// Set initial visual state based on current favorites
				if (theme.Favorites.isFavorited(productData.id)) {
					heartButton.classList.add('is-favorited');
				} else {
					heartButton.classList.remove('is-favorited');
				}

				// Add click handler directly to each button as it's created
				heartButton.addEventListener('click', function (e) {
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();

					// Use the existing toggleFavorite but add immediate visual feedback
					if (theme.Favorites && theme.Favorites.toggleFavorite) {
						theme.Favorites.toggleFavorite(heartButton);

						// Force visual update with CSS classes instead of replacing SVG
						var productId = heartButton.dataset.productId;
						if (theme.Favorites.isFavorited(productId)) {
							heartButton.classList.add('is-favorited');
						} else {
							heartButton.classList.remove('is-favorited');
						}
					}

					return false;
				});
			}
		});

		// Update heart states after adding them
		if (theme.Favorites && theme.Favorites.updateAllHeartStates) {
			theme.Favorites.updateAllHeartStates();
		}
	};

	const extractProductData = (gridItem) => {
		try {
			// Try multiple methods to get product data
			const productId =
				gridItem.dataset.productId ||
				gridItem.querySelector('[data-product-id]')?.dataset.productId;

			// Get product URL from main link
			const productLink = gridItem.querySelector('a[href*="/products/"]');
			if (!productLink) return null;

			const productUrl = productLink.href;
			const handle = productUrl.split('/products/')[1]?.split('?')[0];

			// Get product title
			const titleElement = gridItem.querySelector(
				'.grid-product__title, .product-title, h3, h2'
			);
			const title = titleElement
				? titleElement.textContent.trim()
				: 'Product';

			// Get product price (collection pages already have correct "from" format)
			const priceElement = gridItem.querySelector(
				'.grid-product__price, .price, .product-price, [class*="price"]'
			);
			const price = priceElement
				? priceElement.textContent.trim()
				: 'Price not available';

			// Get product image
			const imageElement = gridItem.querySelector('img');
			const image = imageElement ? imageElement.src : '';

			return {
				id: productId || handle,
				handle: handle,
				title: title,
				price: price,
				image: image,
				url: productUrl
			};
		} catch (e) {
			console.warn('Could not extract product data:', e);
			return null;
		}
	};

	const createHeartButton = (productData) => {
		const button = document.createElement('button');
		button.className = 'js-favorite-btn';
		button.setAttribute('data-product-id', productData.id);
		button.setAttribute('data-product-handle', productData.handle);
		button.setAttribute('data-product-title', productData.title);
		button.setAttribute('data-product-price', productData.price);
		button.setAttribute('data-product-image', productData.image);
		button.setAttribute('data-product-url', productData.url);
		button.setAttribute('aria-label', 'Add to favorites');
		button.setAttribute('type', 'button');

		// Create heart SVG with CSS-controllable classes
		button.innerHTML = `
      <svg aria-hidden="true" class="icon icon-heart" viewBox="0 0 64 64">
        <path class="heart-path" d="M32 52s-12-8-20-16c-4-4-6-9-6-14 0-11 9-20 20-20 3 0 6 1 8 3 2-2 5-3 8-3 11 0 20 9 20 20 0 5-2 10-6 14-8 8-20 16-20 16z" stroke-width="2"/>
      </svg>
    `;

		return button;
	};

	const findImageContainer = (gridItem) => {
		// Try to find the best container for the heart - prioritize image elements
		const containers = [
			gridItem.querySelector('.grid-product__image-mask'),
			gridItem.querySelector('.grid-product__image'),
			gridItem.querySelector('.image-wrap'),
			gridItem.querySelector('.product-image'),
			gridItem.querySelector('[class*="image"]'),
			gridItem.querySelector('img')?.parentElement, // Parent of the image
			gridItem.querySelector('a') // fallback to first link
		];

		// Return the first container that exists
		const container = containers.find((container) => container !== null);

		return container;
	};

	return {
		init: init,
		addHeartsToGrid: addHeartsToGrid
	};
})();

/*============================================================================
  Product Page Heart Injection - FIXED PRICE EXTRACTION
==============================================================================*/
theme.productPageHearts = (function () {
	function init() {
		// Only run on product pages
		if (!document.body.classList.contains('template-product')) {
			return false;
		}

		addHeartToProductPage();

		return true;
	}

	const addHeartToProductPage = () => {
		// Check if heart already exists
		const existingHeart = document.querySelector('.product-page-favorite');
		if (existingHeart) {
			existingHeart.remove();
		}

		// Extract product data from the product page
		const productData = extractProductPageData();
		if (!productData) {
			return;
		}

		// Create heart button
		const heartButton = createProductHeartButton(productData);

		// Find the product image container
		const imageContainer = findProductImageContainer();
		if (imageContainer) {
			// Create wrapper div for positioning
			const heartWrapper = document.createElement('div');
			heartWrapper.className = 'product-page-favorite';
			heartWrapper.appendChild(heartButton);

			// Position the heart wrapper
			heartWrapper.style.cssText = `
        position: absolute !important;
        top: 12px !important;
        right: 12px !important;
        z-index: 10 !important;
        width: 44px !important;
        height: 44px !important;
        pointer-events: auto !important;
      `;

			// Make sure container supports absolute positioning
			if (getComputedStyle(imageContainer).position === 'static') {
				imageContainer.style.position = 'relative';
			}

			// Add to image container
			imageContainer.appendChild(heartWrapper);

			// Set initial state
			if (theme.Favorites.isFavorited(productData.id)) {
				heartButton.classList.add('is-favorited');
			}

			// Add click handler
			heartButton.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();

				if (theme.Favorites && theme.Favorites.toggleFavorite) {
					theme.Favorites.toggleFavorite(heartButton);

					// Update visual state
					var productId = heartButton.dataset.productId;
					if (theme.Favorites.isFavorited(productId)) {
						heartButton.classList.add('is-favorited');
					} else {
						heartButton.classList.remove('is-favorited');
					}
				}

				return false;
			});
		}
	};

	const extractProductPageData = () => {
		try {
			// Method 1: Try to get product ID from theme variables or data attributes
			let productId = null;
			const productElement = document.querySelector('[data-product-id]');
			if (productElement) {
				productId = productElement.dataset.productId;
			}

			// Fallback: try to find in window.theme or other global variables
			if (!productId && window.theme && window.theme.product) {
				productId = window.theme.product.id;
			}

			// Method 2: Try to extract from page elements
			const titleElement = document.querySelector(
				'h1, .product-title, .product__title, [class*="product-title"], .product-single__title'
			);

			const imageElement = document.querySelector(
				'.product img, .product__image img, img[class*="product"], .product-single__photos img'
			);

			return {
				id:
					productId ||
					window.location.pathname
						.split('/products/')[1]
						?.split('?')[0],
				handle: window.location.pathname
					.split('/products/')[1]
					?.split('?')[0],
				title: titleElement
					? titleElement.textContent.trim()
					: document.title,
				price: '', // We'll extract the price on heart click as variant pricing isn't loaded yet
				image: imageElement ? imageElement.src : '',
				url: window.location.href
			};
		} catch (e) {
			console.warn('Error extracting product page data:', e);
			return null;
		}
	};

	const createProductHeartButton = (productData) => {
		const button = document.createElement('button');
		button.className = 'js-favorite-btn product-heart-btn';
		button.setAttribute('data-product-id', productData.id);
		button.setAttribute('data-product-handle', productData.handle);
		button.setAttribute('data-product-title', productData.title);
		button.setAttribute('data-product-price', productData.price);
		button.setAttribute('data-product-image', productData.image);
		button.setAttribute('data-product-url', productData.url);
		button.setAttribute('aria-label', 'Add to favorites');
		button.setAttribute('type', 'button');

		// Create heart SVG with proper styling
		button.innerHTML = `
      <svg aria-hidden="true" class="icon icon-heart" viewBox="0 0 64 64" style="width: 20px; height: 20px;">
        <path class="heart-path" d="M32 52s-12-8-20-16c-4-4-6-9-6-14 0-11 9-20 20-20 3 0 6 1 8 3 2-2 5-3 8-3 11 0 20 9 20 20 0 5-2 10-6 14-8 8-20 16-20 16z" stroke-width="2"/>
      </svg>
    `;

		return button;
	};

	const findProductImageContainer = () => {
		// Try multiple selectors to find the product image container
		const containerSelectors = [
			'.product__main-photos', // Motion theme specific - try this first
			'[data-product-single-media-group]', // Motion theme specific
			'.product__photos', // Motion theme specific
			'.product-single__photos',
			'.product__images',
			'.product-images',
			'.product__gallery',
			'[class*="product"][class*="image"]',
			'.product-single',
			'.product'
		];

		for (let selector of containerSelectors) {
			const container = document.querySelector(selector);
			if (container) {
				const bounds = container.getBoundingClientRect();

				// Only return containers that have actual dimensions
				if (bounds.width > 0 && bounds.height > 0) {
					return container;
				}
			}
		}

		// Fallback: try to find any element with actual dimensions that contains product images
		const fallbackSelectors = [
			'.flickity-viewport', // Motion theme uses Flickity
			'.product-slideshow', // From product-images.liquid
			'.product-main-slide img' // Find image and use its parent
		];

		for (let selector of fallbackSelectors) {
			const element = document.querySelector(selector);
			if (element) {
				let container = selector.includes('img')
					? element.parentElement
					: element;
				const bounds = container.getBoundingClientRect();

				if (bounds.width > 0 && bounds.height > 0) {
					return container;
				}
			}
		}

		return null;
	};

	return {
		init: init,
		addHeartToProductPage: addHeartToProductPage
	};
})();

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
	// Small delay to ensure all elements are rendered
	setTimeout(function () {
		theme.Favorites.init();

		// Initialize collection hearts
		if (theme.collectionHearts) {
			if (theme.collectionHearts.init())
				theme.Favorites.pageType = 'collection';
		}

		// Initialize product page hearts
		if (theme.productPageHearts) {
			if (theme.productPageHearts.init())
				theme.Favorites.pageType = 'product';
		}
	}, 100);
});
